// Modal Store

const state = {
  visibility: false,
  type: null,
}

const getters = {
  isVisible: ({ visibility }) => visibility,
}

const actions = {}

const mutations = {
  SET_VISIBILITY: state => {
    state.visibility = !state.visibility
    if (!state.visibility) {
      state.type = null
    }
  },
  SET_TYPE: (state, payload) => {
    state.type = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
